import { Modal, ModalProps, Tooltip, Flex, Loader } from "@mantine/core";
import { IconPresentationAnalytics } from "@tabler/icons-react";
import { useEffect } from "react";

import { useGetApi } from "../../../hooks";
import {
  StyledActionIcon,
  StyledTable,
  StyledTd,
  StyledTh,
  StyledTr,
} from "../../../styled";
import { DateTimeDisp } from "../DateTime";

interface Props {
  opened: boolean;
  close: () => void;
  elementName?: string;
  params: any;
  apiUrl: string;
  dataHeaders?: string[];
  dataKeys?: string[];
  onView?: (row: any) => void;
  mapRow?: (row: any) => any;
  [key: string]: ModalProps[keyof ModalProps];
}

const HistoryModal = ({
  opened,
  close,
  params,
  apiUrl,
  elementName,
  dataHeaders,
  dataKeys,
  onView,
  mapRow,
  ...modalProps
}: Props) => {
  const { data, refetch, isLoading, error } = useGetApi<{ list: any }>({
    request: apiUrl,
    fetchOnInit: false,
    mapper: (data) => {
      return { list: data?.list ?? data?.data ?? [] }
    }
  });
  const paramsKey = JSON.stringify(params);
  useEffect(() => {
    if (opened && params)
      void refetch({
        params,
      });
  }, [opened, paramsKey]);

  const rows: any[] | undefined = mapRow
    ? (data?.list ?? []).map(mapRow)
    : data?.list;

  const showCustomData = dataHeaders && dataKeys && rows && rows.length > 0;

  return (
    <Modal
      title={
        <span>
          History for{" "}
          <span style={{ fontWeight: 200 }}>{elementName ?? ""}</span>
        </span>
      }
      opened={opened}
      onClose={close}
      size="xl"
      {...modalProps}>
      {isLoading || (!data && !error) ? (
        <Flex justify="center" py="md">
          <Loader />
        </Flex>
      ) : rows && rows.length > 0 ? (
        <StyledTable style={{ fontSize: 14 }}>
          <StyledTr>
            {showCustomData &&
              dataHeaders.map((header: string) => (
                <StyledTh key={header}>{header}</StyledTh>
              ))}
            <StyledTh>Action</StyledTh>
            <StyledTh>User</StyledTh>
            <StyledTh>Date</StyledTh>
            {onView && <StyledTh></StyledTh>}
          </StyledTr>
          {rows.map((row: any) => (
            <StyledTr key={row.id}>
              {showCustomData &&
                dataKeys.map((key: string) => (
                  <StyledTd key={key}>{row.data?.[key]}</StyledTd>
                ))}
              <StyledTd>{row.action}</StyledTd>
              <StyledTd>{row.detail}</StyledTd>
              <StyledTd>
                <DateTimeDisp lt={row.date ?? row.createddateLT} utc={row.dateUTC ?? row.createddateUTC} color="text" />
              </StyledTd>
              {onView && (
                <StyledTd>
                  <Flex>
                    <Tooltip label="View">
                      <StyledActionIcon mx="auto" onClick={() => onView(row)}>
                        <IconPresentationAnalytics />
                      </StyledActionIcon>
                    </Tooltip>
                  </Flex>
                </StyledTd>
              )}
            </StyledTr>
          ))}
        </StyledTable>
      ) : (
        <div style={{ textAlign: "center" }}>No history was found</div>
      )}
    </Modal>
  );
};

export default HistoryModal;
